import { IListItem } from '../../list-page/interfaces/interfaces';
import { getCategoryFromURL, sendGaEventImpressions } from '../../../domain/marketing/gtm-provider';


/**
 * send analytics data on page load
 */
export const sendInitialAnalytics = (stateProducts: IListItem[], listName: string) => {

    // get first 20 items
    const products = stateProducts.slice(0, 20);

    const impressions = products.map((product, index) => {
        return {
            name: product.documentName,
            id: product.skuNumber,
            price: product.skuPrice,
            category: getCategoryFromURL(product.documentUrlPath),
            variant: 'NONE',
            list: listName,
            position: index + 1,
        };
    });

    sendGaEventImpressions(impressions);
};

